import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";

import { featureViewQueryKeys } from "@/app/data/featureViewQueryKeys";
import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import {
  arrayQueryDataOrFallback,
  requireArrayQueryData,
} from "@/common/utils/queryDataValidation";
import { FeatureViewDTO } from "@reflag/shared/featureViewAPI";

export function useFeatureViewsData() {
  const { appId } = useEnvironment();
  const selectFeatureViews = useCallback(
    (featureViews: FeatureViewDTO[]) =>
      arrayQueryDataOrFallback<FeatureViewDTO>(featureViews as unknown, {
        queryName: "featureViews",
        source: "react-query-cache",
        context: { appId },
      }),
    [appId],
  );

  return useQuery({
    queryKey: featureViewQueryKeys.list(appId),

    queryFn: () =>
      api
        .get<"/apps/:appId/feature-views">(`/apps/${appId}/feature-views`)
        .then((res) =>
          requireArrayQueryData<FeatureViewDTO>(res.data as unknown, {
            queryName: "featureViews",
            source: "api-response",
            context: { appId },
          }),
        ),
    select: selectFeatureViews,
    enabled: !!appId,
    staleTime: 10000, // 10 seconds
  });
}
